import watch from 'redux-watch';

export class ShopHighlighterCtrl {

    constructor($scope, $location, $timeout, storeServ, mapServ) {
        this.$scope = $scope;
        this.$location = $location;
        this.$timeout = $timeout;
        this.storeServ = storeServ;
        this.mapServ = mapServ;

        this.ngOnInit();

        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    /**
     *  Init.
     */

    ngOnInit() {
        let watchShopMarkersReady = watch(this.storeServ.getState, 'shopMarkersReady');
        
        this.stopWatchingShopMarkersReady = this.storeServ.subscribe(watchShopMarkersReady((newVal, oldVal, objectPath) => {
            newVal && this.onShopMarkersReady();
        }));
    }

    onShopMarkersReady() {
        this.getPosCodeFromUrl();

        this.removeThePosQueryParam();

        this.getMarkersFromClusterer();

        this.markerToClick = this.getMarkerToTriggerClickOn();

        if (this.markerToClick) {
            this.storeServ.dispatch({
                type: 'POINT_MAP_TO_COORDINATES',
                coordinates: {
                    location: {
                        lat: this.markerToClick.getPosition().lat(),
                        lng: this.markerToClick.getPosition().lng()
                    },
                    viewport: null
                }
            });

            this.triggerClickOnMarkerTimeout = this.$timeout(() => {
                this.storeServ.dispatch({
                    type: 'TRIGGER_CLICK_ON_MARKER',
                    posCode: this.posCode
                });
            }, 400);
        }
    }

    getPosCodeFromUrl() {
        this.posCode = this.$location.search().pos;
    }

    removeThePosQueryParam() {
        this.$location.search('pos', null);
    }

    getMarkersFromClusterer() {
        this.shopMarkers = this.markerClusterer.getMarkers();
    }

    getMarkerToTriggerClickOn() {
        return this.shopMarkers.filter((marker) => {
            return marker.customProperties.shop.pos === this.posCode;
        })[0];
    }

    ngOnDestroy() {
        this.stopWatchingShopMarkersReady();

        this.$timeout.cancel(this.triggerClickOnMarkerTimeout);

        this.storeServ.getState().pointMapToCoordinates && this.storeServ.dispatch({
            type: 'POINT_MAP_TO_COORDINATES',
            coordinates: null
        });

        this.storeServ.getState().triggerClickOnMarker && this.storeServ.dispatch({
            type: 'TRIGGER_CLICK_ON_MARKER',
            posCode: null
        });
    }
}

ShopHighlighterCtrl.$inject = ['$scope', '$location', '$timeout', 'storeServ', 'mapServ'];

export const shopHighlighter = function() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: ShopHighlighterCtrl,
        bindToController: {
            markerClusterer: '=',
            map: '='
        }
    };
};
